import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// list1 is array of item objects
// list2 is array of partNumber strings
// if list2 contains partNumber value and property 'deleted: true' in list1
// remove 'deleted' property and return
// else return all other items
export default (function (list1, list2) {
  return list1.map(function (item) {
    if (list2.includes(item.partNumber) && item.deleted) {
      var newItem = _objectSpread({}, item);

      delete newItem.deleted;
      return _objectSpread({}, newItem);
    }

    return item;
  });
});